import { FileType } from '@/app/constants/fileType'
import type { UploadedFileApiDto } from '../model/imports.api.dto'
import { IMPORT_DRIVER_ACCEPTED_FILE_EXTENSIONS } from '../config'

// Certyfikat i status odczytu serwer ustawia tylko dla plików tachografu.
export function isTachographFile(file: UploadedFileApiDto): boolean {
  if (file.fileType === FileType.Ddd) return true
  if (file.fileType !== FileType.Unknown) return false
  const name = (file.fileName ?? '').toLowerCase()
  return IMPORT_DRIVER_ACCEPTED_FILE_EXTENSIONS.some((ext) => name.endsWith(ext))
}

// Pliki z danymi (GPS, TMS, nieobecności...) serwer zapisuje już przy odczycie.
export function isDataFile(file: UploadedFileApiDto): boolean {
  return !isTachographFile(file) && Boolean(file.format)
}

// Starsze importy mają w bazie nazwę formatu sprzed zmiany marki.
export function formatName(format?: string | null): string {
  return (format ?? '').replace(/SuperTacho/g, 'EasyTacho')
}
